import Dropdown from "./Dropdown";

const DropDownTheme = ({
  value,
  onChange,
  options,
  optionsValue,
  disabled,
  width,
  maxWidth,
  sx,
  containerSx,
  inputSx,
}) => {
  const mappedOptions = options.map((label, idx) => ({
    label,
    value: optionsValue[idx],
  }));

  return (
    <Dropdown
      variant="autocomplete"
      multiple
      value={value}
      onChange={onChange}
      options={mappedOptions}
      disabled={disabled}
      placeholderKey="dropdown.theme"
      chipLimit={3}
      selectedPluralKey="dropdown.selected_plural"
      width={width}
      maxWidth={maxWidth}
      sx={sx}
      containerSx={containerSx}
      inputSx={inputSx}
    />
  );
};

export default DropDownTheme;
